import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { ChangedField, DocumentComparison } from '../../../core/models/organization.models';
import { ComparisonLabelPipe } from './comparison-label.pipe';
import { mapComparisonValue } from './comparison-value-label.map';

@Component({
  selector: 'app-comparison-dialog',
  imports: [ComparisonLabelPipe],
  templateUrl: './comparison-dialog.html',
  styleUrl: './comparison-dialog.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ComparisonDialog {
  readonly isOpen = input(false);
  readonly comparisons = input<DocumentComparison[]>([]);
  readonly isLoading = input(false);
  readonly viewMode = input<'table' | 'single'>('table');
  readonly title = input('Confronto Versioni Documenti');
  readonly description = input('Visualizza i campi modificati rispetto alla versione precedente.');

  readonly closeDialog = output<void>();

  readonly expandedElement = signal<DocumentComparison | null>(null);

  readonly singleComparison = signal<DocumentComparison | null>(null);

  readonly columns = [
    { key: 'expand', label: '' },
    { key: 'document_type', label: 'Tipo Documento' },
    { key: 'doc_subtype', label: 'Sottotipo' },
    { key: 'changes_count', label: 'Campi Modificati' },
  ] as const;

  toggleExpand(element: DocumentComparison): void {
    this.expandedElement.update((prev) => (prev === element ? null : element));
  }

  constructor() {
    this.singleComparison.set(this.comparisons()[0] ?? null);
  }

  requestClose() {
    if (this.isLoading()) return;
    this.expandedElement.set(null);
    this.closeDialog.emit();
  }

  getMeaningfulChanges(fields: ChangedField[]): ChangedField[] {
    return fields.filter((f) => f.previous_value !== '' || f.current_value !== '');
  }

  getEmptyCount(fields: ChangedField[]): number {
    return fields.filter((f) => f.previous_value === '' && f.current_value === '').length;
  }

  displayValue(fieldName: string, value: string, documentType?: string): string {
    return mapComparisonValue(fieldName, value, documentType);
  }

  getSingleComparison(): DocumentComparison | null {
    return this.comparisons()[0] ?? null;
  }
}
